var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-chip',{staticClass:"semaforo-chip",attrs:{"color":_vm.color,"dark":""}},[_c('v-icon',{attrs:{"left":""}},[_vm._v(_vm._s(_vm.icon))]),_vm._v(" "+_vm._s(_vm.label)+" ")],1)
}
var staticRenderFns = []

export { render, staticRenderFns }